// extracted by css-extract-rspack-plugin
export default {"formWrapper":"form-wrapper--lIQaWsM3ugMXK3ew","date":"date--oicIWlAMzOaQmIUV","dateError":"date-error--o4MEVxNC374wxa0Z"};